var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-information"},[_c('span',{staticClass:"icon-support"}),_c('h3',[_vm._v(_vm._s(_vm.$t("support.no_ticket")))]),_c('p',[_vm._v(_vm._s(_vm.$t("support.need_help")))])])}
var staticRenderFns = []

export { render, staticRenderFns }